import { Breadcrumb, Button, Col, Form, Input, List, Radio, Row, Steps } from "antd";
import "../dc.scss";
import "./dcCharge.scss";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import ReactInputMask from "react-input-mask";
import React, { useEffect, useState } from "react";
import { useDealer } from "../../../../tools/api";
import {
	commaDigits,
	complexDigitToman,
	convertCurrencyToRial,
	convertCurrencyToToman,
	convertPersian,
	isEmpty,
	regexFormater,
	validateInput,
} from "../../../../tools/tools";
import { useLocation, useNavigate } from "react-router-dom";
import { clearFormData } from "../../../../reducer/serviceReducer";
import { useDispatch } from "react-redux";
import { switchPlanID } from "../../../../tools/services";
import Profile from "../../../corporate_subscriber_search/corporate/profile/profile";

const DCCharge = () => {
	const [t] = useTranslation("global");
	const [frmCharge] = Form.useForm();
	const { queryValidChargeByPlanId, isValidMSISDNToBuyCharge } = useDealer();
	const nav = useNavigate();
	const location = useLocation();

	const dispatch = useDispatch();

	const [dc, setDc] = useState({
		purchase: location?.state || null,
		isPriceActive: false,
		chargeList: [],
	});

	useEffect(() => {
		const loadServChargeList = async () => {
			if (dc?.chargeList.length === 0) {
				let payload = {
					planid: switchPlanID().directCharge,
				};
				let response = await queryValidChargeByPlanId(payload);
				if (response) {
					response.push(0);
					setDc((dc) => ({ ...dc, chargeList: response }));
				}
			}
		};
		loadServChargeList();
	}, []);
	const handleComma = (e) => {
		let v = e.target.value;
		if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
			v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
			e.target.value = v;
			return v;
		} else {
			return "";
		}
	};
	const handleSubmit = async () => {
		try {
			dispatch(clearFormData(["dcCharge"]));
			let valid = await frmCharge.validateFields();
			if (valid) {
				let payload = {
					msisdn: dc?.purchase?.inT_MSISDN || regexFormater(valid.msisdn).removeSpace(),
					planid: switchPlanID().directCharge,
				};
				let response = await isValidMSISDNToBuyCharge(payload);
				if (response) {
					nav(_adr.Root + _adr.DCPurchase.Index + _adr.DCPurchase.Shop + _adr.DCPurchase.Prefactor, {
						state: {
							...response,
							msisdn: payload.msisdn,
							chargeAmount: dc.isPriceActive ? convertCurrencyToRial(regexFormater(valid.desiredamount).removeComma()) : valid.amount,
							purchase: dc?.purchase || null,
						},
					});
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleChangeCharge = (state) => {
		if (state.target.value === 0) {
			setDc((dc) => ({ ...dc, isPriceActive: true }));
		} else {
			setDc((dc) => ({ ...dc, isPriceActive: false }));
		}
	};
	return (
		<>
			<div className="container-main container-dc">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("directCharge.title") }]}
					/>
					<div className="title-page">
						<h3>{t("directCharge.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main dc-container">
						<div className="g-format-page">
							{dc.purchase && <Profile Profile={dc?.purchase} state />}
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={0}
											items={[
												{
													title: "مبلغ شارژ",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "رسید",
												},
											]}
										/>
									</div>
								</div>
								<div className="charge-container">
									<div className="holder-charge">
										{!dc?.purchase ? (
											<div className="title-page">
												<h3>لطفا شماره موبایل و مبلغ شارژ خود را وارد کنید</h3>
											</div>
										) : (
											<div className="title-page">
												<h3>مبلغ شارژ خود را وارد کنید</h3>
											</div>
										)}

										<div className="holder-form">
											<Form form={frmCharge} layout="vertical">
												<Row>
													{!dc?.purchase && (
														<Col xl={8} lg={12} md={24} xs={24} sm={24}>
															<Form.Item
																className="input-normal"
																label="شماره موبایل"
																name="msisdn"
																rules={[
																	validateInput({
																		t: t,
																		validate: true,
																		type: "msisdnOrg",
																	}),
																]}>
																<div>
																	<ReactInputMask
																		onChange={(e) => {
																			e.target.value = convertPersian(e.target.value);
																		}}
																		className="msisdn-mask"
																		dir="ltr"
																		mask="0\9\9\99 99 99 99"
																	/>
																</div>
															</Form.Item>
														</Col>
													)}

													<Col span={7}></Col>
												</Row>
												<Row>
													<Col xl={8} lg={12} md={24} xs={24} sm={24}>
														<Form.Item className="input-normal" name="amount" rules={[validateInput({ t: t, validate: true })]}>
															<Radio.Group className="opt-charge" onChange={handleChangeCharge}>
																{dc?.chargeList.map((item, key) => (
																	<Radio key={key} value={item}>
																		{item === 0 ? (
																			<>مبلغ دلخواه</>
																		) : (
																			<>
																				<span>{complexDigitToman(item)}</span> تومان
																			</>
																		)}
																	</Radio>
																))}
															</Radio.Group>
														</Form.Item>
													</Col>
												</Row>
												{dc?.isPriceActive && (
													<Row>
														<Col lg={12} xl={6}>
															<Form.Item
																className="input-normal"
																label="مبلغ دلخواه"
																name="desiredamount"
																rules={[
																	validateInput({
																		t: t,
																		validate: true,
																		type: "charge",
																	}),
																]}>
																<Input
																	onInput={handleComma}
																	onPaste={(e) => e.preventDefault()}
																	maxLength="8"
																	dir="ltr"
																	addonAfter="تومان"
																	autoComplete="off"
																/>
															</Form.Item>
														</Col>
													</Row>
												)}
											</Form>
										</div>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
										مرحله بعد
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>
		</>
	);
};

export default DCCharge;
